import { getBrandFromHost } from "@theme/config/theme.config";
import { getEnvironmentType } from "@utils/helpers/getEnvironmentType";

const host = window.location.hostname.toLowerCase();
const brand = getBrandFromHost(host);
const environmentType = getEnvironmentType(brand);
const getOppositeCompanyName = environmentType === "NIM" ?  "Fair Go Finance Pty Ltd" : "Nimble Australia Pty Ltd";

export default getOppositeCompanyName;